import { IconButton } from '@mui/material';
import { Settings } from '@vy/ui-design-system';
import { useRef } from 'react';
import type { FilterField, FilterLineType } from '../../../../components/new-design/vyTableFilter';
import { VyTableColumnSettings } from '../../../../components/new-design/table/table-column-settings';
import type { ColumnConfig } from '../../../../hooks/use-grid-column-settings';
import { RevenueReportToolbar } from '../../reports-components/RevenueReportToolbar';
import { reportIconButtonSx } from '../../reports-components/report-toolbar-styles';

type CustomerRevenueReportToolbarProps = {
  onSearchChange: (value: string) => void;
  searchValue?: string;
  fromDate: Date | null;
  onFromDateChange: (date: Date | null) => void;
  recognizedUpTo: Date | null;
  onRecognizedUpToChange: (date: Date | null) => void;
  filterFields: FilterField[];
  filters: FilterLineType[];
  onFiltersChange: (filters: FilterLineType[]) => void;
  showChart: boolean;
  onShowChartChange: (show: boolean) => void;
  onExport: () => void;
  columnSettings: ColumnConfig[];
  isColumnSettingsOpen: boolean;
  onOpenColumnSettings: () => void;
  onCloseColumnSettings: () => void;
  onColumnVisibilityChange: (field: string, isVisible: boolean) => void;
};

export const CustomerRevenueReportToolbar: React.FC<CustomerRevenueReportToolbarProps> = ({
  onSearchChange,
  searchValue,
  fromDate,
  onFromDateChange,
  recognizedUpTo,
  onRecognizedUpToChange,
  filterFields,
  filters,
  onFiltersChange,
  showChart,
  onShowChartChange,
  onExport,
  columnSettings,
  isColumnSettingsOpen,
  onOpenColumnSettings,
  onCloseColumnSettings,
  onColumnVisibilityChange,
}) => {
  const columnSettingsAnchorRef = useRef<HTMLDivElement | null>(null);

  return (
    <RevenueReportToolbar
      onSearchChange={onSearchChange}
      searchValue={searchValue}
      fromDate={fromDate}
      onFromDateChange={onFromDateChange}
      toDate={recognizedUpTo}
      onToDateChange={onRecognizedUpToChange}
      useDateRangePicker
      filterFields={filterFields}
      filters={filters}
      onFiltersChange={onFiltersChange}
      showChart={showChart}
      onShowChartChange={onShowChartChange}
      onExport={onExport}
      trailingActions={
        <>
          <div ref={columnSettingsAnchorRef}>
            <IconButton
              onClick={onOpenColumnSettings}
              sx={reportIconButtonSx}
              aria-label="Column settings"
            >
              <Settings />
            </IconButton>
          </div>
          <VyTableColumnSettings
            anchorEl={columnSettingsAnchorRef.current}
            open={isColumnSettingsOpen}
            onClose={onCloseColumnSettings}
            columns={columnSettings}
            handleColumnVisibilityChange={onColumnVisibilityChange}
            mandatoryColumnsCount={0}
          />
        </>
      }
    />
  );
};
